import { render, staticRenderFns } from "./DialogDeleteBot.vue?vue&type=template&id=8cdea1b8&"
import script from "./DialogDeleteBot.vue?vue&type=script&lang=js&"
export * from "./DialogDeleteBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports